import * as React from 'react';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import {
  Button,
  cn,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@sandtech-hub-monorepo/ui-kit';
import {
  emailLabel,
  emailPlaceholder,
  emailRequiredValidationMessage,
  forgotPasswordButtonLabel,
} from '../../../../../stringsManager';

import { MailIcon, Loader2 } from 'lucide-react';

const formSchema = z.object({
  email: z.string().min(1, emailRequiredValidationMessage).email(),
});

interface ForgotPasswordFormProps {
  onSubmit: (values: z.infer<typeof formSchema>) => void;
  loading: boolean;
  className?: string;
  defaultEmail?: string;
}

export const ResetPasswordForm = ({
  className,
  loading,
  onSubmit,
  defaultEmail = '',
  ...props
}: ForgotPasswordFormProps) => {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: defaultEmail,
    },
  });

  return (
    <div className={cn('grid gap-4 text-foreground', className)} {...props}>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <FormField
            disabled={loading}
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="font-normal">{emailLabel}</FormLabel>
                <FormControl>
                  <Input
                    placeholder={emailPlaceholder}
                    {...field}
                    endAdornment={<MailIcon />}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button disabled={loading} type="submit" className="w-full">
            {loading ? (
              <Loader2 className="animate-spin" />
            ) : (
              forgotPasswordButtonLabel
            )}
          </Button>
        </form>
      </Form>
    </div>
  );
};
